import { Component, Input } from '@angular/core';
import { DataGridComponent } from 'src/app/core/data-grid.component';
import { State } from '@progress/kendo-data-query';
import { tap } from 'rxjs/operators';
import { Connection } from '../models/connection';
import { SubscriptionDataService } from '../services/subscription-data.service';
import { Topic } from '../models/topic';
import { ExternalEditGridComponent } from 'src/app/core/external-edit-grid.component';
import { Subscription } from '../models/subscription';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent extends ExternalEditGridComponent<Subscription> {

  public gridState: State = {
    sort: [
      {
        field: "Name",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 10,
  };
    
  constructor(
    private dataService: SubscriptionDataService
  ) {
    super(Subscription);
  }

  @Input() public connection: Connection;
  @Input() public topic: Topic;

  ngOnInit() {
    super.ngOnInit();
  }

  protected refresh() {
    this.view = this.dataService
      .get(this.gridState, `&$filter=connectionId eq ${this.connection.Id} and topic eq '${this.topic.Name}'`)
      .pipe(tap(() => (this.loading = false)));
  }

  public saveHandler(sub: Subscription) {
  }  

  public removeHandler({ dataItem }) {
  }  
}
